var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"operation-tool-label"},[(_vm.product)?_c('ProductIcon',{staticClass:"operation-tool-label__icon",attrs:{"product":_vm.product,"alt":"","aria-hidden":"true"}}):_c('i',{staticClass:"fa-solid fa-file operation-tool-label__fallback",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }